export default "__VITE_ASSET__CcqOHWp3__"